export const mergeIds = (current: unknown, added: string[]): string[] => [
  ...new Set([...(Array.isArray(current) ? (current as string[]) : []), ...added]),
];

type AgentOption = { value: string; label: string };

export const mergeAgentIds = (
  current: unknown,
  added: AgentOption[],
  labelFor: (id: string) => string
): AgentOption[] => {
  const existing = Array.isArray(current) ? (current as (AgentOption | string)[]) : [];
  const normalised = existing.map((item) =>
    typeof item === 'string' ? { value: item, label: labelFor(item) } : item
  );
  const seen = new Set(normalised.map((item) => item.value));

  return [...normalised, ...added.filter((item) => !seen.has(item.value))];
};
